import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
export const BACKEND_BASE = BACKEND_URL;

export const api = axios.create({ baseURL: API });

// Public
export const fetchProducts = () => api.get("/products").then((r) => r.data);
export const fetchClients = () => api.get("/clients").then((r) => r.data);
export const fetchTestimonials = () => api.get("/testimonials").then((r) => r.data);
export const submitContact = (payload) => api.post("/contact", payload).then((r) => r.data);

// Admin — products
export const createProduct = (p) => api.post("/products", p).then((r) => r.data);
export const updateProduct = (id, p) => api.patch(`/products/${id}`, p).then((r) => r.data);
export const deleteProduct = (id) => api.delete(`/products/${id}`).then((r) => r.data);

// Admin — clients
export const createClient = (c) => api.post("/clients", c).then((r) => r.data);
export const updateClient = (id, c) => api.patch(`/clients/${id}`, c).then((r) => r.data);
export const deleteClient = (id) => api.delete(`/clients/${id}`).then((r) => r.data);

// Admin — testimonials
export const createTestimonial = (t) => api.post("/testimonials", t).then((r) => r.data);
export const updateTestimonial = (id, t) => api.patch(`/testimonials/${id}`, t).then((r) => r.data);
export const deleteTestimonial = (id) => api.delete(`/testimonials/${id}`).then((r) => r.data);

// Admin — contacts
export const fetchContactSubmissions = () => api.get("/contact-submissions").then((r) => r.data);
export const deleteContactSubmission = (id) => api.delete(`/contact-submissions/${id}`).then((r) => r.data);

// Admin — uploads
export const uploadClientLogo = (file) => uploadImage("/uploads/client-logo", file);
export const uploadProductImage = (file) => uploadImage("/uploads/product-image", file);

function uploadImage(endpoint, file) {
  const fd = new FormData();
  fd.append("file", file);
  return api
    .post(endpoint, fd, { headers: { "Content-Type": "multipart/form-data" } })
    .then((r) => r.data);
}

// Helper to resolve relative upload URLs to absolute
export const absoluteUrl = (url) => {
  if (!url) return url;
  if (/^https?:\/\//i.test(url)) return url;
  return `${BACKEND_BASE}${url}`;
};
